module.exports = __webpack_public_path__ + "static/media/undraw_message.d5248035.png";